import {apiKey, getLogger, endpoint, interceptors, sourceInfo} from '@advisor/services/sdk';
import {
  PlatformSettingsService,
  // requests
  CreateOrUpdateSegmentFeatureOptions,
  // responses
  SegmentDetailsResponse,
} from '@digital-advice/ms-platform-settings-sdk';

export default class PlatformSettingsServices {
  static async sdkService(): PlatformSettingsService {
    const service = await new PlatformSettingsService({
      logger: getLogger(),
      apiKey,
      endpoint,
      interceptors,
      sourceInfo,
    });

    return service;
  }

  /**
   * Gateway endpoint: updateSegmentFeatureValue
   * @param {SegmentDetailsResponse} payload
   */
  static async updateSegmentFeatureValue(payload: CreateOrUpdateSegmentFeatureOptions): Promise<SegmentDetailsResponse> {
    const platformService = await this.sdkService();

    return platformService.createOrUpdateFeature(payload);
  }
}
